import { Vue, Component, Prop } from 'vue-property-decorator';
import fileDownload from 'js-file-download';

import { CustomerDocumentListItemDTO } from '@/../client-generator/generated-clients/customer-documents';
import documentsService from '@/core/api/documents-service';

import DocumentListItem from '../DocumentListItem/DocumentListItem.vue';

@Component({
  components: {
    DocumentListItem,
  },
  i18n: {
    messages: {
      it: {
        employeeIdInvalid: 'ID dipendente non valido',
        fileNotFound: 'Documento non trovato',
        fileNotAssociatedWithUser: "File non più associato all'utente",
      },
    },
  },
})
export default class DocsList extends Vue {
  @Prop({ default: [] }) documents!: CustomerDocumentListItemDTO[];
  @Prop({ default: false }) simpleView!: boolean;

  isLoading = false;

  async handleDownload(document: CustomerDocumentListItemDTO) {
    this.isLoading = true;

    try {
      const response = await documentsService.download(
        document.documentId as number,
        document.filename as string,
        null
      );

      fileDownload(response.data, document.filename as string);

      const downloadsNo = document.downloadCount as number;
      if (downloadsNo === 0) {
        this.$emit('document-download');
      }

      (document.downloadCount as number)++;
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 400:
          messageError = this.$t('employeeIdInvalid').toString();
          break;
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        case 404:
          messageError = this.$t('fileNotFound').toString();
          break;
        case 406:
          messageError = this.$t('fileNotAssociatedWithUser').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.isLoading = false;
    }
  }
}
